module.exports = "/_next/static/images/45080a4ec821d34ac4b67c39cbd6cd14-multiproduct-xs.jpg";